import React, { Component } from 'react';
import styled from 'styled-components';
import { NavLink, withRouter } from 'react-router-dom';
import { Flex } from 'grid-styled';
import { connect } from 'react-redux';
import $ from "jquery";
import isMobile from 'ismobilejs';
import shortid from 'shortid';

import api from 'api';
import WP, { fetchWP } from 'WP';
import Container from 'partials/Container';
import logo from 'images/logo.svg';
import search from 'images/search.svg';
import close from 'images/close.svg';
import SmartLink from 'partials/SmartLink';
import css from 'css';
import SearchResults from 'partials/SearchResults';
import { isIOSSafari } from 'helpers';

import { setSearchBlur } from 'store';

class Header extends Component {

    constructor() {
        super();

        this.initialSearchResults = {
            count: 0,
            results: {
                post: [],
                page: [],
                employees: [],
                projects: []
            }
        }

        this.state = {
            menu1: null,
            menu2: null,
            searchActive: false,
            searchQuery: '',
            searching: false,
            searchResults: this.initialSearchResults,
            mobileMenuVisible: false,
            headerTop: 0,
        }

        this.lastScrollPosition = 0;
        this.menuOpenAtScrollPos = 0;
    }

    componentWillMount() {
        api.getMenuById(WP.primary_menu_1_id)
            .then(res => {
                //console.log('MENU: ',res);
                if(res.data.items[0]) {
                    this.setState({ menu1: res.data.items });
                }
            })
            .catch(e => console.log('Failed to load main menu', e));
        api.getMenuById(WP.primary_menu_2_id)
            .then(res => {
                //console.log('MENU: ',res);
                if(res.data.items[0]) {
                    this.setState({ menu2: res.data.items });
                }
            })
            .catch(e => console.log('Failed to load main menu', e));

        this.root = document.getElementById("root");

        window.addEventListener('resize', this._onResize.bind(this));

        if(window.matchMedia("(max-width: 768px)").matches) {
            window.addEventListener('scroll', this._onScroll.bind(this));
        }
    }

    _onResize() {
        // reset menu when swithing from < 768 to larger screen and the other way around
        if(
            (window.outerWidth > 768 && this.state.mobileMenuVisible) ||
            (window.outerWidth <= 768 && this.state.searchActive)
        ) {
            this.setState({
                searchActive: false,
                searchQuery: '',
                searching: false,
                searchResults: this.initialSearchResults,
                mobileMenuVisible: false,
            });
            this.props.setSearchBlur(false);
            this.root.style.overflow = 'auto';
        }
    }

    // used to show / hide sticky header on mobile
    _onScroll(animateUp = true) {

        if(window.scrollY === 0) {
            this.setState({ headerTop: 0 });
            this.lastScrollPosition = window.scrollY;
            return;
        }

        console.log('scroll');

        if(window.scrollY > this.lastScrollPosition + 100 && window.scrollY > 100) {
            // scrolll down
            $('#header').addClass('animate-up');
            if(animateUp) {
                setTimeout(() => {
                    this.setState({ headerTop: 0 });
                    $('#header').removeClass('animate-up');
                }, 300);
            } else {
                this.setState({ headerTop: 0 });
            }
            this.lastScrollPosition = window.scrollY;
        } else if(window.scrollY < this.lastScrollPosition - 100) {
            // scroll up
            this.setState({ headerTop: window.scrollY });
            this.lastScrollPosition = window.scrollY;
        }

    }

    _openSearch() {
        this.setState({ searchActive: true });
        this.refs.searchInput.focus();
        this.props.setSearchBlur(true);

        this.root.style.overflow = 'hidden';
    }

    _closeSearch() {

        if(window.matchMedia("(max-width: 768px)").matches)
            return;

        this.setState({
            searchActive: false,
            searchQuery: '',
            searching: false,
            searchResults: this.initialSearchResults,
        });
        this.props.setSearchBlur(false);

        this.root.style.overflow = 'auto';
    }

    _onSearch(e) {
        const query = e.target.value;
        this.setState({
            searchQuery: query,
            searching: true
        });

        //if(!this.props.searchBlur && query !== '')
            //this.props.setSearchBlur(true);

        if(this.props.searchBlur && query === '') {
            //this.props.setSearchBlur(false);
            this.setState({
                searchResults: this.initialSearchResults,
                searching: false
            });
            return;
        }

        api.search(query)
            .then(res => {
                this.setState({
                    searchResults: res.data,
                    searching: false
                });
            });
    }

    _switchLanguage(e, lang) {
        e.preventDefault();

        let redirectPath = lang === 'en' ? '/en' : '/';

        // set the pll_language cookie to new value
        let now = new Date();
        now.setFullYear(now.getFullYear()+1);
        document.cookie = `pll_language=${lang}; expires=${now.toGMTString()}; path=/;`;

        const currentView = this.props.currentView;
        // if current view data are saved in store && their translation info is available
        if(currentView && currentView.translation_paths && currentView.translation_paths[lang]) {

            if(currentView.translation_paths[lang]) { // only if translation path is available (page has translation) - if not redirection to home from above will be used
                currentView.translation_paths[lang] = currentView.translation_paths[lang].replace('/en/', '/');
                redirectPath = redirectPath + currentView.translation_paths[lang];
                redirectPath = redirectPath.replace('//', '/');
            }

            //remove hash
            redirectPath = redirectPath.split('#')[0];

        }

        // add a unique 'id' to url (required on some browsers when changing lang. on home page)
        if(redirectPath === '/' || redirectPath === '/en/') {
            redirectPath = redirectPath+'?c='+shortid.generate();
        }

        if(process.env.NODE_ENV === 'development') {
            // ferth WP and redirect to corresponding translation OR home page
            fetchWP(lang, redirectPath);
        } else {
            // redirect to corresponding translation OR home page
            window.location.replace(redirectPath);
        }

    }

    _blured() {
        const max768 = window.matchMedia("(max-width: 768px)").matches;
        return this.props.searchBlur && !max768 ? 'blured blured-on-search' : 'blured-on-search';
    }

    _toggleMobileMenu() {
        let searchActive = false;
        if(!this.state.mobileMenuVisible && window.matchMedia("(max-width: 768px)").matches) {
            searchActive = true;

            // sticky header on mobile adjustments
            this.menuOpenAtScrollPos = window.scrollY;

            this.root.style.overflow = 'hidden';
            $('html, body').addClass('menuOpen');
        }
        if(this.state.mobileMenuVisible && window.matchMedia("(max-width: 768px)").matches) {
            this.root.style.overflow = 'auto';
            $('html, body').removeClass('menuOpen');

            // sticky header on mobile adjustments
            this.lastScrollPosition = window.scrollY;
            window.scrollTo({top: this.menuOpenAtScrollPos});
            this.setState({ headerTop: this.menuOpenAtScrollPos }, this._onScroll(false));
        }
        this.setState({
            mobileMenuVisible: !this.state.mobileMenuVisible,
            searchQuery: '',
            searchActive: searchActive
        });
    }

    _onMenuLinkClick() {
        this.setState({ mobileMenuVisible: false, searchQuery: '' });
        this.root.style.overflow = 'auto';
        if(window.matchMedia("(max-width: 768px)").matches) window.scrollTo({top: 0 });
        $('html, body').removeClass('menuOpen');
    }

    _onResultClick() {
        this.setState({
            searchActive: false,
            mobileMenuVisible: false,
            searchQuery: '',
            searching: false,
            searchResults: this.initialSearchResults,
        });
        this.props.setSearchBlur(false);
        this.root.style.overflow = 'auto';
        $('html, body').removeClass('menuOpen');
    }

    render() {
        const { menu1, menu2, searchActive, searchQuery, mobileMenuVisible, searching, searchResults, headerTop } = this.state;

        return (
            <Wrapper id="header" className={mobileMenuVisible ? 'mobile-menu-open' : ''} headerTop={headerTop}>
                <Container>
                    <Flex justify="space-between">

                        <Logo>
                            <NavLink to={WP.lang === 'en' ? '/en' : '/'} onClick={this._onMenuLinkClick.bind(this)} className={this._blured.bind(this)()}>
                                <img src={WP.assets+logo} alt="HLM logo" className="logo" />
                            </NavLink>
                        </Logo>

                        <button className={['chamburger', mobileMenuVisible ? 'open' : ''].join(' ')} onClick={this._toggleMobileMenu.bind(this)}>
                            <span />
                        </button>

                        <Navigation role="navigation" className={mobileMenuVisible ? 'open' : ''}>

                            <Flex className={[this._blured.bind(this)(), 'main-nav'].join(' ')} wrap>
                                <Nav>
                                    {menu1 && menu1.map((item, i) => {
                                        return (
                                            <li key={i}>
                                                <SmartLink to={item.url} onClick={this._onMenuLinkClick.bind(this)} activeClassName="active" >{item.title}</SmartLink>
                                                {item.children &&
                                                    <ul>
                                                        {item.children.map((child, c) => <li key={c}><SmartLink to={child.url} onClick={this._onMenuLinkClick.bind(this)} activeClassName="active" >{child.title}</SmartLink></li>)}
                                                    </ul>
                                                }
                                            </li>
                                        )
                                    })}
                                </Nav>
                                <Nav>
                                    {menu2 && menu2.map((item, i) => {
                                        return (
                                            <li key={i}>
                                                <SmartLink to={item.url} onClick={this._onMenuLinkClick.bind(this)} activeClassName="active" >{item.title}</SmartLink>
                                                {item.children &&
                                                    <ul>
                                                        {item.children.map((child, c) => <li key={c}><SmartLink to={child.url} onClick={this._onMenuLinkClick.bind(this)} activeClassName="active" >{child.title}</SmartLink></li>)}
                                                    </ul>
                                                }
                                            </li>
                                        )
                                    })}
                                </Nav>
                            </Flex>

                            <Flex flexDirection="column" className="search-and-lang-switcher" >
                                <SearchBox className={[searchActive ? 'active' : ''].join(' ')} ie11={navigator.userAgent.match(/rv:11/)}>
                                    <button className="openSearch" onClick={this._openSearch.bind(this)}>
                                        <img src={WP.assets+search} alt="Show search input"/> <span>{WP.trans.search}</span>
                                    </button>
                                    <div className="searchInput">
                                        <input ref="searchInput" type="text" placeholder="Hva leter du etter?" value={searchQuery} onChange={this._onSearch.bind(this)} />
                                        <button onClick={this._closeSearch.bind(this)}>
                                            <img src={WP.assets+(window.matchMedia("(max-width: 768px)").matches ? search : close)} alt="Hide search input"/>
                                        </button>
                                    </div>
                                    {searchActive &&
                                        <SearchResults searchResults={searchResults} searching={searching} searchQuery={searchQuery} onResultClick={this._onResultClick.bind(this)} />
                                    }
                                </SearchBox>
                                {/** }  <LangSwitcher className={this._blured.bind(this)()}>
                                    {WP.lang === 'en' && <a onClick={e => this._switchLanguage(e, 'no')}>Norsk</a> }
                                    {WP.lang === 'no' && <a onClick={e => this._switchLanguage(e, 'en')}>English</a> }
                                </LangSwitcher>
                                **/}
                                <MobileSocialLinks className="mobile-social-links">
                                    <a href={WP.options.facebook_link}>Facebook</a>
                                    <a href={WP.options.instagram_link}>Instagram</a>
                                </MobileSocialLinks>
                            </Flex>

                        </Navigation>

                    </Flex>
                </Container>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentView: state.currentView,
        searchBlur: state.searchBlur
    }
}

const actions = {
    setSearchBlur
}

export default connect(mapStateToProps, actions)(withRouter(Header));

const Wrapper = styled.header`
    padding: 50px 0;

    @media(max-width: 768px) {
        padding: 30px 0;
        position: absolute;
        top:0;
        left:0;
        width:100%;
        height: 100px;
        z-index: 999;
        background: transparent;
        transition: transform .3s ease-in-out, background .3s ease-in-out;
        ${props => props.headerTop > 0 ? `
            position: fixed;  
            top:-65px;
            transform: translateY(65px);
            background: #fff;
            height: 65px;
            padding: 13px 0;
            .logo {
                width: 45px;
                height: 34px;
            }
            .chamburger {
                margin-top:7px;
            }
        ` : `
            position: absolute;
            transition: background .3s ease-in-out;
            top:0px;
            background: transparent;
            transform: translateY(0px);
            .logo {
                width:64px;
                height:34px;
                min-width:64px;
                min-height:34px;
            }
        `}
        &.animate-up {
            transform: translateY(-100px);
            background: transparent;
        }
    }

    &.mobile-menu-open {
        position: fixed;
        width: 100%;
        height: 100%;
        background: #F8F8F8;
        z-index: 1000;
        overflow-y: auto;
    }

    .chamburger {
        display:none;
        position: relative;
        height:18px;
        width:25px;
        cursor:pointer;
        @media (max-width: 768px) {
            display:block;
            z-index:900;
        } 
        span, &:before, &:after, span:after {
            content: '';
            width:25px;
            height:2px;
            background: #1A1A1A;
            position:absolute;
            top: 50%;
            left:0;
            display:block;
            transition: all .2s ease-in-out;
        }
        span { margin-top: -1px; }
        span:after { margin-top: -1px; }
        &:before { top:0; }
        &:after { top:auto; bottom:0; }

        &.open {
            &:before { opacity: 0; }
            &:after { opacity: 0; }
            span {
                transform: rotate(45deg);
                &:after {
                    transform: rotate(-90deg);
                }
            }
        }
    }

`

const Logo = styled.div`
    flex: 1 0 auto;
    a {
        display:inline-block;
        padding-bottom: 0;
        border:none;
        img {
            width: 110px;
            height: 59px;
            bottom: -2px;
            position: relative;
        }
    }
`

const Navigation = styled.nav`
    display:flex;
    flex:1 0 auto;
    max-width: ${css.sizes.rightColumn};
    justify-content: space-between;

    @media (max-width: 768px) {
        position:absolute;
        top: -30px;
        left:0;
        display:none;
        background: #F9F9F9;
        width:calc(100% + 50px);
        margin-left:-25px;
        max-width: calc(100% + 50px);
        z-index: 500;
        padding: 25px;

        &.open {
            display:block;
            min-height:100vh;
            ${props => {  
                if(isIOSSafari()) return `min-height: calc(100vh - 75px);`;
                if(isMobile.android.device) return `min-height:auto;`;
            }}
            .main-nav {
                min-height: calc(100vh - 50px - 100px);
                justify-content: center;
                flex-direction: column;
                ${props => {  
                    if(isIOSSafari()) return `min-height: calc(100vh - 150px - 100px);`;
                    if(isMobile.android.device) return `min-height: calc((100vh - 50px) - 160px);`;
                }}
            }
        }
    }
`

const Nav = styled.ul`
    margin: 0 60px 0 0;
    li {
        margin-bottom:8px;
        a {
            border-bottom:none;
            font-size:16px;
            font-family: ${css.fonts.bg_medium};
            @media (max-width: 768px) {
                font-size:26px;
                line-height: 52px;
                font-family: ${css.fonts.bg_regular};
            }
            &:active, &:focus, &:visited {
                color: #000000;
            }
            &:hover {
                border-bottom-width: 1px;
                border-bottom-style: solid;
                border-bottom-color: inherit;
            }
        }
        ul {
            padding-top:8px;
            li {
                a {
                    color: #797979;
                    @media (max-width: 768px) {
                        font-family ${css.fonts.bg_light};
                    }
                    &:active, &:focus, &:visited {
                        color: #797979;
                        border-bottom-color: #9e9e9e;
                    }
                }
                ul {
                    display:none;
                }
            }
        }
    }

    @media (max-width: 768px) {
        margin: 0 0 0 0;
        width:100%;
    }
`

const LangSwitcher = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-right:-5px;
    a {
        cursor:pointer;
        font-size:16px;
        font-family: ${css.fonts.bg_medium};
        margin: 0 5px;
        &:active, &:focus, &:visited {
            color: #000000;
        }
        &:hover {
            border-bottom:none;
        }
    }
    @media (max-width: 768px) {
        margin-bottom:-37px;
    }
`

const SearchBox = styled.div`
    margin-bottom: 22px;
    display:flex;
    justify-content: flex-end;
    font-size:16px;
    font-family: ${css.fonts.bg_medium};
    overflow:hidden;
    position:relative;
    height: 33px;
    .openSearch {
        font-size:16px;
        font-family: ${css.fonts.bg_medium};
        cursor:pointer;
        display: flex;
        justify-content: flex-end;
        transition: all .3s ease-in-out;
        z-index: 1;
        position:relative;
        z-index:101;
        img {
            margin-right: 8px;
            width:18px;
            height:18px;
        }
    }
    .searchInput {
        transition: all .3s ease-in-out;
        opacity:0;
        width:0;
        z-index: 2;
        position:relative;
        z-index:102;
        button {
            transition: all .3s ease-in-out;
            cursor:pointer;
            position:absolute;
            top: 50%;
            right:0;
            transform: scale(0);
            margin-top:-11px;
        }
        input {
            width:100%;
            background: transparent;
            border: none;
            border-bottom:1px solid #191919;
            font-size:16px;
            padding: 6px 0;
            outline: none;
            &::placeholder {
                color: #191919;
                opacity: 1;
            }
            &:-ms-input-placeholder {
                color: #191919;
            }
            &::-ms-input-placeholder {
                color: #191919;
            }
        }
    }

    @media (max-width: 768px) {
        margin: 10px 0 0;
        justify-content: flex-start;
        flex-wrap: wrap;
        height:auto;
        margin-bottom:20px;
        .openSearch {
            span {
                display:none;
            }
        }
    }

    &.active {
        @media (max-width: 768px) {
            display:block;

        }
        .searchInput {
            opacity:1;
            position: fixed;
            max-width: 1250px;
            width: 100%;
            ${props => props.ie11 ? `
                left: 50%;
                transform: translateX(-50%);
            ` : ``}

            input { 
                font-size: 22px;
            }

            @media (max-width: 1252px) {
                width: calc(100% - 50px);
                input { 
                    font-size:16px;
                }
            }

            @media (max-width: 768px) {
                width: 100%;
                position: relative;
                //margin-left: 29px;
            }
            button {
                transform: scale(1);
            }
        }
        .openSearch {
            transform: scale(0);
            opacity:0;
            margin-right:-55px;
        }
    }
`

const MobileSocialLinks = styled.div`
    display:none;
    @media (max-width: 768px) {
        display: block;
        padding-top: 15px;
        width: 50%;
        a {
            cursor:pointer;
            font-size: 14px;
            margin-right: 10px;
            finct-family: ${css.fonts.bg_regular};
        }
    }
`



// WEBPACK FOOTER //
// ./src/partials/Header.js